<div class=" mt-4" *ngIf="PayoutTour">
  <section class="my-4">
    <div class="scrollmenu">
      <a [routerLink]="['/PayOut/AccountBalance']">Account Balance</a>
      <a [routerLink]="['/PayOut/ManagePayOutContact']">PayOut Contact</a>
      <a [routerLink]="['/PayOut/BeneficiaryList']">PayOut Beneficiary</a>

      <!-- <a [routerLinkActive]="active" class="active menu" [routerLink]="['/PayOut/PayoutLedgers']">PayOut Ledger</a> -->
      <a [routerLink]="['/PayOut/PayOutTransactions']">PayOut Transaction</a>
      <a [routerLink]="['/PayOut/PayOutBatches']">PayOut settlement</a>
      <!-- <a [routerLink]="['/PayOut/managePayoutAccountdetails']">Payout Security</a> -->
<a [routerLink]="['/PayOut/ManagePayOutBulkUploadFiles']">Bulk File Upload</a>
<a  [routerLink]="['/PayOut/PayoutPostback']">PayOut PostBack Url</a>
<a [routerLink]="['/reports/payoutorderfailurelog']">PayOut Failure </a>
<!-- <a [routerLink]="['/PayOut/PayoutReports']">Reports</a>
<a [routerLink]="['/PayOut/PayoutSecurityTransactions']">Payout Security Transactions</a> -->
    </div>
  </section>
  <section>
    <div class="row" *ngIf="Workclose">
      <div class="col-md-12">

        <div class="row">
          <div class="col-lg-12">
            <div class="card shadow1">
              <div class="card-body"
                style="background-image: url(assets/img/invoice-images/invoice-bg.png); background-repeat: no-repeat; background-position: bottom; background-position:left bottom;">
                <h3 class="font-weight-bold d-inline">How it Works</h3>

                <a class="d-inline float-right" (click)="close()"><i class="fas fa-times"></i></a>

                <div class="hori-timeline pt-5 get-width" dir="ltr">
                  <ul class="list-inline events">
                    <li class="list-inline-item event-list">
                      <div class="px-4">
                        <div class="event-date bg-soft-primary text-white">Step 1</div>
                        <h5 class="font-weight-bold pb-3">Create Pay Button</h5>
                        <p class="text-muted">Create GST based invoices instantly and notify
                          your customer via sms or email.</p>

                      </div>

                    </li>
                    <li class="list-inline-item event-list">
                      <div class="px-4">
                        <div class="event-date bg-soft-success text-white">Step 2</div>
                        <h5 class="font-weight-bold pb-3"> Receive Payments</h5>
                        <p>Your customers can make payments directly via the invoice link.</p>
                        <div>

                        </div>
                      </div>
                    </li>

                  </ul>
                </div>
              </div>
            </div>
            <!-- end card -->
          </div>
        </div>

      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-12">
        <div class="float-right">

          <a  class="back-tour mr-3" type="a" data-toggle="modal" data-target="#exampleModalCenter">Need Help ?
            Take a Tour <i class="far fa-lightbulb"></i></a>
          <div class="dropdown d-inline">
            <button class="dash-btns mr-3" type="button" data-toggle="dropdown">Download &nbsp;<i
                class="fas fa-caret-down"></i>
            </button>
            <ul class="dropdown-menu text-center">
              <li><a  id="btnExportBatch" (click)="readAndExportToExcelData()">Excel</a></li>

            </ul>
          </div>
          <!-- <a class="box-button" type="button" id="filtering" (click)="filters()" tooltip="Filter"
        aria-describedby="tooltip-9">  <img src="assets/img/filter-icon.png" alt="" style="width: 20px; height: 20px;"></a>
      -->
          <button class="dash-btns" type="button" id="filtering" (click)="filters()"> <i class="fa fa-filter" aria-hidden="true"></i>
            Filter</button>

        </div>


      </div>
      <div class="col-md-12">
        <small class=" font-16 gary-t ">Currently we are displaying last 7 days report. For more details please click on
          Filter</small>
      </div>

    </div>
    <div class="row  my-4" *ngIf="filtering">
      <div class="col-md-12">
        <div class="card-1 p-4">
          <h4 class="font-26 gary-t">Filter Your Result</h4>
          <p>Please Fill the details to filter your result</p>
          <div class="col-md-12">
            <!-- filtering starts -->
            <form>
              <div class="row m-0">
                <div class="col-md-3 mt-4">

                  <div class="form-group">
                    <label class="customlabel">Date</label>
                    <div class="selectcustom mb-0">
                      <ngx-select [items]="Range" id="daterange" placeholder="Today" [formControl]="daterange"
                      (ngModelChange)="checkRangeType()" required>
                    </ngx-select>
                    </div>

                  </div>
                </div>
                <div class="col-md-3 mt-4" *ngIf="Rfromdate">


                  <div class="form-group">
                    <label class="customlabel">From Date</label>
                    <input class="formcontrol-user1 form-control" type="date" placeholder="From Date" id="fromdate"
                      [formControl]="fromdate"  (change)="checkDateRange()">
                  </div>

                </div>
                <div class="col-md-3 mt-4" *ngIf="Rfromdate">

                  <div class="form-group">
                    <label class="customlabel">To Date</label>
                    <input class="formcontrol-user1 form-control" type="date" placeholder="To Date" id="todate"
                      [formControl]="todate" (change)="checkDateRange()">
                  </div>
                </div>
                <span class="text-danger" *ngIf="isStartDateGreaterthenEndDate">From Date Should not be greater than To
                  Date</span>
                <!-- <div class="col-md-3  mt-4">
                <div class="form-group">
                  <ngx-select [items]="Status" id="cardStatus" placeholder="Status" [formControl]="cardStatus" required>
                  </ngx-select>
                </div>
              </div> -->
                <div class="col-md-3  mt-4">

                  <div class="form-group">
                    <label class="customlabel">Transaction Type</label>
                    <input class="formcontrol-user1 form-control" type="text" placeholder="Transaction Type"
                      id="TransactionType" [formControl]="TransactionType">
                  </div>
                </div>

                <!-- <div class="col-md-3  mt-4">
                <div class="form-group">
                  <input class="formcontrol-user form-control" type="text" placeholder="EntryDetail" id="EntryDetail" [formControl]="EntryDetail">
                </div>
              </div> -->
                <div class="col-md-3  mt-4">

                  <div class="form-group">
                    <label class="customlabel">Amount</label>
                    <input class="formcontrol-user1 form-control" type="text" placeholder="Amount" id="Amount"
                      [formControl]="Amount">
                  </div>
                </div>
                <div class="col-md-3 mt-4">
                  <label class="customlabel">Select</label>
                  <div class="form-group">
                    <ngx-select [items]="symbol" id="amountcheck" placeholder="Select" [formControl]="amountcheck" required>
                    </ngx-select>
                  </div>
                </div>
              </div>
            </form>
            <!-- filtering ends -->
          </div>
          <div class="col-md-12 text-right">
            <div class="text-right mt-3" *ngIf="!isCustomDateSelected">
              <button class="dash-btns mr-3" type="button" id="filtering" (click)="selectedaterange()"
                matTooltip="New Sale Transaction"> Search</button>
            </div>

            <div class="text-right mt-3" *ngIf="isCustomDateSelected">
              <button class="dash-btns" type="button" id="filtering" [disabled]="!isreportsbtnActive" (click)="search()"
                matTooltip="New Sale Transaction"> Search</button>
            </div>
            <!-- <a href="" style="color: #d40055;">Clear</a> -->
          </div>
        </div>
      </div>

    </div>
    <div class="row">
      <div class="col-md-12">
        <ngx-datatable #table class='bootstrap no-detail-row' (columnMode)="'Force'" [footerHeight]="50"
          [rowHeight]="'auto'"[columnMode]="'force'" [scrollbarH]="true" [limit]="10" [rows]="rows" >
          <ngx-datatable-column name="Action">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <a class=" edit" [routerLink]="['/PayOut/ViewPayoutLedgers',{Id: row.Id}]" data-toggle="tooltip"
                data-placement="top" title="View">
                <img src="./assets/ViewDetails.svg">
              </a>

            </ng-template>
          </ngx-datatable-column>

          <!-- [width]="200" -->
          <ngx-datatable-column name="TransactionType" [width]="200">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.TransactionType}}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="EntryDetail">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.EntryDetail}} </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Amount">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div class="robot font400">{{row.Amount}}</div>
            </ng-template>

          </ngx-datatable-column>
          <ngx-datatable-column name="Status">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.Status}}
            </ng-template>
          </ngx-datatable-column>

          <!-- <ngx-datatable-column name="City">
          <ng-template let-row="row" ngx-datatable-cell-template><div class=" robot font400">{{row.Phone}}</div></ng-template>
        </ngx-datatable-column> -->

          <ngx-datatable-column name="Balance">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div class=" robot font400">{{row.Balance}}</div>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="DateTime">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div class=" robot font400">{{row.UpdatedDateTime | date:'d/M/yy, h:mm a' }}</div>
            </ng-template>
          </ngx-datatable-column>




        </ngx-datatable>
      </div>
    </div>
  </section>
</div>



<!-- Tour strats -->

<div class="" *ngIf="tourDiv">
  <div class="">
    <div class="row">
      <div class="col-md-12">
        <div class="pt-5 text-right">
          <button class="btn btn-warning" (click)="SkipTour()">Skip <i class="fas fa-step-forward"></i></button>

        </div>
      </div>
    </div>
  </div>
  <div class="" *ngIf="PayoutStep1">
    <div class="one">
      <div class="row  tourstep">
        <div class="col-md-6  d-none d-sm-none d-md-block">
          <img class="w-100 mt-3" src="http://fastswiff.com/assets/img/vpos-tour-images/payout/manage-payout3.png"
            style="width: 350px ;">
        </div>
        <div class="col-md-6">
          <div class="mt-5  py-3">
            <img src="assets/img/logo.png" style="width: 100px;">
          </div>
          <h3 style="font-size: 40px; line-height: 48px;
                    margin: 16px 0 8px 0;
                    font-weight: bold;
                    color: #0d2366;">Payout Ledger</h3>
          <ul class="padding-b-xs">
            <li>Keep track of your payments with a Payout ledger </li>
            <li>Take away the stress and manual efforts of balancing your ledger</li>
          </ul>


          <div class="pt-5 text-right" style="vertical-align: bottom;     position: absolute;
                    bottom: 17px;
                    right: 64px;">
            <button class="box-button" (click)="GetStarted() ">Get Started</button>

          </div>
          <div class="pt-5 text-right" style="vertical-align: bottom;     position: absolute;
                    bottom: 25px;
                    right: 175px;">
            <input class="formcontrol-user form-control" class="d-inline mb-0 mr-2" type="checkbox"
              (click)="ShowMeAgain()" />
            <p class="d-inline mb-0 text-primary">Do not show me again</p>
          </div>
        </div>
      </div>
    </div>


  </div>

  <div class="" *ngIf="PayoutStep2">
    <div class="one">
      <div class="row  tourstep">
        <div class="col-md-12 pt-3 ">
          <h3 class="pl-5" style="font-size: 40px; line-height: 48px;margin: 16px 0 8px 0; font-weight: bold;
                  color: #0d2366;">What makes Invoices great?</h3>
        </div>
        <div class="Features">
          <div class="Feature">
            <img class="Feature-icon" src="assets/img/invoice-images/gst.svg">
            <div class="Feature-title">GST compliant</div>
            <p class="Feature-desc">Add GST, discounts and shipping details, all in an invoice and let our
              invoicing solution do the calculation for you.</p>
          </div>
          <div class="Feature">
            <img class="Feature-icon" src="assets/img/invoice-images/partial_payments.svg">
            <div class="Feature-title">Partial payments</div>
            <p class="Feature-desc">Enable partial payments for your customers at the time of invoice
              creation directly from the dashboard.</p>
          </div>
          <div class="Feature">
            <img class="Feature-icon" src="assets/img/invoice-images/download_option.svg">
            <div class="Feature-title">Download Option</div>
            <p class="Feature-desc">Let your customers save and download .pdf version of invoices for future
              reference.</p>
          </div>
        </div>
        <div class="pt-5 text-right" style="vertical-align: bottom;     position: absolute;
                 bottom: 24px;
          right: 185px;
          font-size: 18px;
          cursor: pointer;;">
          <a class="box-a" (click)="backSubmit()">Back</a>

        </div>
        <div class="pt-5 text-right" style="vertical-align: bottom;     position: absolute;
              bottom: 17px;
              right: 64px;">
          <button class="box-button" (click)="GetStarted()">Get Started</button>

        </div>
      </div>
    </div>

  </div>
</div>


















<!-- tour Ends -->











<!-- Modal -->
<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content card-1 p-1">
      <div class="modal-header" style="border-bottom:none">

        <button type="button" class="close blue1-t font-16" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">Skip</span>
        </button>
      </div>
      <div class="modal-body" style="border-bottom:none">
        <div class="row ">
          <div class="mx-auto">
            <img src="assets/img/new/tour.svg" alt="" height="150">
          </div>
          <div class="col-md-12 text-center">
            <h4 class="gary-t font-20 pt-3 ">PayOut Ledger</h4>
            <div class="lite-gray-t text-left py-2">
              <ul class="padding-b-xs">
                <li>Keep track of your payments with a Payout ledger </li>
                <li>Take away the stress and manual efforts of balancing your ledger</li>
              </ul>
            </div>
            <div class=" text-center">
              <button class="btn blue-btn" data-dismiss="modal" aria-label="Close">Get Started</button>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
